import { gql } from '@apollo/client'

export const scoreGridFragment = gql`
  fragment ScoreGridFragment on ScoreGridDto {
    id
    resultScore
    lastResultScore
    employeePreparationScore
    managerPreparationScore
    date
    scoreGoals {
      id
      viewId
      employeeEvaluation
      reviewerEvaluation
      resultEvaluation
      lastResultEvaluation
    }
  }
`
